import { Widgets, ViewHeadline, ListAltOutlined, SlowMotionVideo } from "@mui/icons-material";
import RateReviewIcon from '@mui/icons-material/RateReview';

interface MenuType {
  id: string;
  title?: string;
  icon: React.ReactNode;
  items: {
    id: string;
    name: string;
    url: string;
    subItems?: {
      name: string;
      url: string;
    }[];
  }[];
}

export const MENU: MenuType[] = [
  {
    id: "1",
    icon: <Widgets />,
    title: "Host",
    items: [
      {
        id: "hostBasicDetails",
        name: "Basic Details",
        url: "/basic-details",
      },
      {
        id: "hostKYC",
        name: "Kyc",
        url: "/kyc",
      },
      // {
      //   id: "hostProfileDetails",
      //   name: "Profile Details",
      //   url: "/profile-details",
      // },
    ],
  },
  {
    id: "2",
    icon: <Widgets />,
    title: "Merchant",
    items: [
      {
        id: "merchantBasicDetails",
        name: "Merchant Basic Details",
        url: "/merchant-basic-details",
      },
      // {
      //   id: "merchantKYC",
      //   name: "Merchant Kyc",
      //   url: "/merchant-kyc-details",
      // },
      {
        id: "bankDetails",
        name: "Bank Details",
        url: "/bank-details",
      },
      {
        id: "organisationDetails",
        name: "Organisation Details",
        url: "/organisation-business-details",
      },
      {
        id: "vendorAgreement",
        name: "Vendor Agreement",
        url: "/vendor-agreement",
      },
      {
        id: "merchantProfileDetails",
        name: "Merchant Profile Details",
        url: "/merchant-profile-details",
      }
    ],
  },
  {
    id: "3",
    title: "Trips",
    icon: <ViewHeadline />,
    items: [
      {
        id: "1-2",
        name: "Create trip",
        url: "/create-new-trips",
      },
      {
        id: "1-3",
        name: "Trip created",
        url: "/trips-created",
      }
    ],
  },
  {
    id: "4",
    title: "Trips",
    icon: <ViewHeadline />,
    items: [
      {
        id: "1-1",
        name: "Assigned Trips",
        url: "/trips",
      },
    ],
  },
  {
    id: "5",
    title: "Bookings",
    icon: <ListAltOutlined />,
    items: [
      // {
      //   id: "5-1",
      //   name: "Slotwise Bookings",
      //   url: "/slotwise-booking",
      // },
      {
        id: "5-1",
        name: "Individual Bookings",
        url: "/individual-booking",
      }
    ],
  },
  {
    id: "6",
    title: "Reviews",
    icon: <RateReviewIcon />,
    items: [
      // {
      //   id: "5-1",
      //   name: "Slotwise Bookings",
      //   url: "/slotwise-booking",
      // },
      {
        id: "6-1",
        name: "Trip Reviews",
        url: "/trip-reviews",
      }
    ],
  },
  {
    id: "7",
    title: "Memories",
    icon: <SlowMotionVideo />,
    items: [
      {
        id: "7-1",
        name: "Memories List",
        url: "/memories-list",
      },
    ],
  }
];
